/**
 *
 * Regular
 *
 * Regular checkbox variation from GDS, created by combining the RadioButton and
 * RegularLabel components.
 *
 */
import withLabelWrapper from '../../../../hoc/withLabelWrapper';
import RegularLabel from '../../../variations/label/RegularLabel';
import BaseRadioButton from '../Base';
var Regular = withLabelWrapper(RegularLabel, {
  type: 'radio'
})(BaseRadioButton);
Regular.displayName = 'Regular';
export default Regular;